import {CategoryWrapper, PageContainer, ProductsTable} from '@/components/organisms'
import {PageHeader} from '@/components/molecules'
import {RadioButton} from '@/components/atoms'
import {Constants, NUMBERS} from '@/utils/constants/commonConstants'
import {FileUploadWithoutModal} from '@/components/organisms/FileUploadWithoutModal'
import {useState} from 'react'
import {uploadFileDescriptionForCSV} from '@/utils/commonTemplate'

const SalesTargetProducts = props => {
  const {setSelectedType, selectedType, uploadComplete, onUpdate, formData = {}, setFormData} = props
  const [uploadError, setUploadError] = useState(false)

  const handleDelete = () => {
    setFormData(prev => ({...prev, ...{mediaFile: []}}))
  }

  return (
    <>
      <PageContainer>
        <div className="sales-target-component gray850 text-white">
          <div className="flex items-center justify-between">
            <PageHeader title={'Products'} />
          </div>

          <div className="radio-wrap flex">
            <RadioButton
              isDark={true}
              items={['Category & Products', 'Upload File with Products']}
              onUpdate={category => {
                setSelectedType(category === NUMBERS.Zero ? Constants.CategoryProducts : Constants.UploadedProducts)
              }}
              reference="radio button"
              selected={selectedType === Constants.CategoryProducts || selectedType === Constants.UploadedProducts}
              size="small"
              className="mr-8"
              id={'category_products'}
            />
          </div>
          <hr className="products-hr" />
          {selectedType === Constants.CategoryProducts && <CategoryWrapper />}
          {selectedType === Constants.UploadedProducts && (
            <FileUploadWithoutModal
              handleDownloadTemplate={() => {}}
              handleViewTable={() => {}}
              description={uploadFileDescriptionForCSV()}
              headerTitle={Constants.UploadProducts}
              acceptedExtensions={Constants.CSV}
              files={formData?.mediaFile?.length > 0 ? [formData?.mediaFile] : []}
              onUpload={file => {
                setFormData(prev => ({...prev, ...{mediaFile: [file?.name]}}))
                setUploadError(false)
              }}
              feedbackType={uploadError ? Constants.Error : Constants.Info}
              helperText={uploadError ? 'File format is not valid. Supported formats: .csv' : ''}
              onUploadError={error => {
                if (error) {
                  setUploadError(true)
                }
              }}
              onUploadDelete={handleDelete}
              variant={formData?.mediaFile?.length > 0 ? Constants.Complete : Constants.Edit}
              type={Constants.Single}
              className="!max-w-full"
              containerClassName="!w-full"
            />
          )}
        </div>
      </PageContainer>
      {selectedType === Constants.CategoryProducts && <ProductsTable onUpdate={onUpdate} isUploadTable={false} />}
      {uploadComplete && <ProductsTable isUploadTable={true} />}
    </>
  )
}

export default SalesTargetProducts
